import React from "react"
import { StaticImage } from "gatsby-plugin-image"
import { Row, Col, Container } from "react-bootstrap"
const BioImage = () => {
  return (
    <Container style={{ marginTop: "30px" }}>
      <Row>
        <Col
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          md={{ span: 12 }}
          lg={{ span: 6 }}
          xl={{ span: 6 }}
          style={{ marginBottom: "35px" }}
        >
          <StaticImage src={"../images/bio1.jpg"} alt={"Pamela bio pic 1"} />
        </Col>
        <Col
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          md={{ span: 12 }}
          lg={{ span: 6 }}
          xl={{ span: 6 }}
          style={{ marginBottom: "35px" }}
        >
          <StaticImage src={"../images/bio2.jpg"} alt={"Pamela bio pic 2"} />
        </Col>
        <Col
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          md={{ span: 12 }}
          lg={{ span: 6 }}
          xl={{ span: 6 }}
          style={{ marginBottom: "35px" }}
        >
          <StaticImage src={"../images/bio3.jpg"} alt={"Pamela bio pic 3"} />
        </Col>
        <Col
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          md={{ span: 12 }}
          lg={{ span: 6 }}
          xl={{ span: 6 }}
          style={{ marginBottom: "35px" }}
        >
          <StaticImage src={"../images/bio4.jpg"} alt={"Pamela bio pic 4"} />
        </Col>
        <Col
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          md={{ span: 12 }}
          lg={{ span: 6 }}
          xl={{ span: 6 }}
          style={{ marginBottom: "35px" }}
        >
          <StaticImage src={"../images/bio5.jpg"} alt={"Pamela bio pic 5"} />
        </Col>
        <Col
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          md={{ span: 12 }}
          lg={{ span: 6 }}
          xl={{ span: 6 }}
          style={{ marginBottom: "35px" }}
        >
          <StaticImage src={"../images/bio6.jpg"} alt={"Pamela bio pic 6"} />
        </Col>
         <Col
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          md={{ span: 12 }}
          lg={{ span: 6 }}
          xl={{ span: 6 }}
          style={{ marginBottom: "35px" }}
        >
          <StaticImage src={"../images/bio7.jpg"} alt={"Pamela bio pic 7"} />
        </Col>
        <Col
          xs={{ span: 12 }}
          sm={{ span: 12 }}
          md={{ span: 12 }}
          lg={{ span: 6 }}
          xl={{ span: 6 }}
          style={{ marginBottom: "35px" }}
        >
          <StaticImage src={"../images/bio8.jpg"} alt={"Pamela bio pic 8"} />
        </Col>
      </Row>
    </Container>
  )
}

export default BioImage
